import React from 'react';
import PropTypes from 'prop-types';
import Picture from '@deporvillage/picture-component';
import { Config } from '@deporvillage/utils-library-component';

import styles from './Clearpay.module.scss';

const Type = {
    Checkout: 'checkout',
    Product: 'product_page',
};

const showLogo = (type) => {
    switch (type) {
        case Type.Product:
            return true;
        case Type.Checkout:
        default:
            return false;
    }
};

const getShowWith = (type) => {
    switch (type) {
        case Type.Product:
            return true;
        case Type.Checkout:
        default:
            return false;
    }
};

const getIntroText = (type) => {
    switch (type) {
        case Type.Product:
            return false;
        case Type.Checkout:
        default:
            return 'Pay in';
    }
};

const Clearpay = ({ type, price, config }) => {
    const elem = React.useRef(null);
    const { locale, currency } = React.useContext(Config);
    const [init, setInit] = React.useState(false);

    React.useEffect(() => {
        /* eslint-disable no-undef */
        let script = document.createElement('script');
        script.src = '//js.afterpay.com/afterpay-1.x.js';
        script.async = true;
        script.setAttribute('fetchpriority', 'low');
        script.onload = () => setInit(true);
        if (config) {
            script.setAttribute('data-min', `${config.min}`);
            script.setAttribute('data-max', `${config.max}`);
        }
        elem.current.appendChild(script);
        /* eslint-enable no-undef */
    }, []);

    return (
        <div className={styles['clearpay-component']}>
            <afterpay-placement
                ref={elem}
                data-locale={locale}
                data-currency={currency}
                data-amount={price}
                data-logo-type='none'
                data-show-with={getShowWith(type)}
                data-size='xs'
                data-intro-text={getIntroText(type)}
                data-modal-link-style='none'
            />
            {init && showLogo(type) ? (
                <div className={styles['logo']}>
                    <Picture
                        name={'Clearpay'}
                        src={'static/product/payment/clearpay.png'}
                        lazy
                        width={87}
                        height={29}
                    />
                </div>
            ) : null}
        </div>
    );
};

Clearpay.propTypes = {
    type: PropTypes.oneOf([Type.Checkout, Type.Product]),
    price: PropTypes.number,
    config: PropTypes.shape({
        min: PropTypes.number,
        max: PropTypes.number,
    }),
};

export { Type as ClearpayType };
export default Clearpay;
